import { render, staticRenderFns } from "./KgjtWebsiteProductEvolutionEdit.vue?vue&type=template&id=66532db0&scoped=true&"
import script from "./KgjtWebsiteProductEvolutionEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductEvolutionEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteProductEvolutionEdit.vue?vue&type=style&index=0&id=66532db0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66532db0",
  null
  
)

export default component.exports